<template>
   <div class="container">
    <section id="editContent" class="columnContainer layerPopupEdit">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.layerpopup}}</h1>
        <div class="mb30">
          <button type="button" class="btn btnWhite" @click="add">팝업 생성</button>
        </div>
        <div class="popupList">
          <div v-if="list.length > 0">
            <Item
              v-for="(item, index) in list"
              :key="index"
              :locale="locale"
              :item="item"
              @addPopup="addPopup"
              @delPopup="delPopup"
              @delItem="delItem"
              @setActive="setActiveItem" />
          </div>
          <p v-else class="nodata">생성된 레이어팝업이 없습니다.</p>
        </div>
      </div>
      <div class="innerSide"><div class="sideBox">
        <Setting
          v-if="activeItem"
          :locale="locale"
          :item="activeItem"
          @updateSetting="updateSetting" />
        <div v-else>레이어팝업을 선택하세요.</div>
      </div></div>
    </section>
    <div id="setContent">
      <div class="innerItem">
        <button type="button" class="btn btnFull btnPrimary" @click="save">{{locale.save}}</button>
      </div>
    </div>
   </div>
</template>

<script>
import regExp from '@/common/regExp'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import Item from '@/components/Layerpopup/Item'
import Setting from '@/components/Layerpopup/Setting'

export default {
  name: 'Layerpopup',
  props: [
    'locale'
  ],
  components: {
    Item,
    Setting
  },
  created () {
    this.init()
  },
  data () {
    return {
      list: [],
      activeItem: null,
      popupItem: {
        id: '',
        name: '',
        active: false,
        service: true,
        url: {
          type: 'page',
          pageId: '',
          url: this.$store.getters['setting/getLangValues'](),
          productId: '',
          target: false,
          pageId_input_active: false,
          pageIdInput: ''
        },
        popup: [],
        setting: {
          close: '1day', // 1day, stay, always
          limitTime: '15:00',
          type: 'modal', // toastup, modal
          slideup: true,
          autoplay: false,
          mobileActive: true,
          tabletActive: true,
          otaOnly: false,
          pagination: false,
          navigation: false
        }
      }
    }
  },
  methods: {
    init () {
      this.$store.commit('onLoading', true)
      this.$store.dispatch('layerpopup/getLayerpopup').then((res) => {
        if (res) {
          this.list = res.list
          if (!this.activeItem) {
            const id = res.list && res.list[0] && res.list[0].id
            this.setActiveItem(id)
          }
        }
        this.$store.commit('onLoading', false)
      })
    },
    add () {
      const newItem = this._.cloneDeep(this.popupItem)
      const id = UNIQUE.mid()
      newItem.id = id
      this.list = [newItem, ...this.list]
      this.setActiveItem(id)
    },
    addPopup (id) {
      const item = this.list.find(x => x.id === id)
      const popup = {
        type: 'page',
        pageId: '',
        url: this.$store.getters['setting/getLangValues'](),
        productId: '',
        target: false
      }
      item.popup = item.popup.concat(popup)
    },
    delPopup (data) {
      const item = this.list.find(x => x.id === data.id)
      item.popup = item.popup.filter((x, i) => i !== data.index)
    },
    delItem (id) {
      if (id) {
        this.list = this.list.filter(x => x.id !== id)
        this.setActiveItem(this.list[0].id)
      }
    },
    setActiveItem (id) {
      const item = this.list.find(x => x.id === id)
      this.list = this.list.map(x => {
        return {
          ...x,
          active: x.id === id
        }
      })
      this.activeItem = item
    },
    updateSetting (data) {
      this.list = this.list.map(x => {
        return {
          ...x,
          setting: x.id === data.id ? data.setting : x.setting
        }
      })
    },
    save () {
      if (window.confirm(this.locale.confirm_save)) {
        const data = {
          updateat: new Date().toISOString(),
          list: this.list
        }
        this.$store.commit('onLoading', true)
        this.$store.dispatch('layerpopup/setLayerpopup', data).then((res) => {
          if (res) {
            alert(this.locale.complete_save)
            this.init()
          }
          this.$store.commit('onLoading', false)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#editContent.columnContainer {
  .sideBox {
    margin-left: 0;
    padding-left: 0;
  }
}
</style>
